import listActions from 'src/modules/flowStep/list/flowStepListActions';
import FlowStepService from 'src/modules/flowStep/flowStepService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'FLOWSTEP_DESTROY';

const flowStepDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: flowStepDestroyActions.DESTROY_STARTED,
      });

      await FlowStepService.destroyAll([id]);

      dispatch({
        type: flowStepDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.flowStep.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/flow-step');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: flowStepDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: flowStepDestroyActions.DESTROY_ALL_STARTED,
      });

      await FlowStepService.destroyAll(ids);

      dispatch({
        type: flowStepDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.flowStep.destroyAll.success'),
      );

      getHistory().push('/flow-step');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: flowStepDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default flowStepDestroyActions;
